import { render, staticRenderFns } from "./BenefitIconItem.vue?vue&type=template&id=e0043e80"
import script from "./BenefitIconItem.vue?vue&type=script&lang=js"
export * from "./BenefitIconItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports